const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getPlanQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlanQuery';
import { getScenariosDatasetQueryOptions } from '@/lib/queries/adaptive-planner/useGetScenariosDatasetQuery';
import { getVirtualResourcesQueryOptions } from '@/lib/queries/adaptive-planner/useGetVirtualResourcesQuery';
import { getTeamsQueryOptions } from '@/lib/queries/teams/useGetTeamsQuery';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(itemPanelSearchSchema),
  loader: async ({
    context: {
      queryClient
    },
    params: {
      planId
    }
  }) => {
    const planNum = Number(planId);
    await queryClient.ensureQueryData(getPlanQueryOptions({
      planId: planNum
    }));
    await queryClient.ensureQueryData(getTeamsQueryOptions());
    await queryClient.ensureQueryData(getScenariosDatasetQueryOptions({
      planId: planNum
    }));
    await queryClient.ensureQueryData(getVirtualResourcesQueryOptions({
      planId: planNum,
      enabled: true
    }));
  },
  pendingComponent: FullSizeSpinner
});